import { supabase } from './supabase';

export const testSupabaseConnection = async () => {
  try {
    // Try to fetch a simple query that doesn't use aggregates
    const { data, error } = await supabase
      .from('employees')
      .select('id')
      .limit(1);

    if (error) {
      throw error;
    }

    console.log('Supabase connection successful!');
    return true;
  } catch (error) {
    console.error('Supabase connection failed:', error);
    return false;
  }
};